import { render } from "./UpdateTaskCustomFieldPage.vue?vue&type=template&id=565f0158&ts=true"
import script from "./UpdateTaskCustomFieldPage.vue?vue&type=script&lang=ts"
export * from "./UpdateTaskCustomFieldPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__